// Zod's "JIT" mode compiles validators with `new Function`, which the strict CSP (no
// 'unsafe-eval', Trusted Types) forbids and reports as a violation. Turn it off before any
// schema is created: this module must stay the FIRST import of main.tsx (ES modules evaluate
// imports in order, and Zod reads the setting when a schema is built).
import { z } from 'zod';

z.config({ jitless: true });
